import { Col, Row } from "react-bootstrap";
import styled from "styled-components";
export const TotalCardsContainer = styled.div`
    
`
export const TotalCards = styled.div`
    width: 100%;
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1em;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
    }
`
export const TotalCardsTitle = styled.h3`
    font-size: 1.3em;
    margin: 1em 0;
`
export const TotalCard = styled.div`
    
    padding: 2em;
    background: rgba(255, 255, 255, .1);
    border-radius: 20px;
`
export const TotalCardWrapper = styled.div`
`
export const TotalCardTitle = styled.h3`
    text-align: center;
`
export const TotalCardSubTitle = styled.h6`
    text-align: center;
    margin-bottom: 2em;
`
export const TotalCardRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .5em;
`
export const TotalCardIcon = styled.div`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(255, 255, 255, .2);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    margin: 1em auto 1em auto;
    
`
export const TotalCardNumber = styled.h6`
    text-align: right;
    font-weight: bold;
    width: 100%;
`
export const TotalCardLabel = styled.h6`
    text-align: left;
    width: 100%;
`
